import { combineReducers } from "@reduxjs/toolkit";
import projectFormReducer from "./projectForm/projectForm.slice";
import projectsListReducer from "./projectsList/projectsList.slice";
import projectDetailsReducer from "./projectDetails/projectDetails.slice";

 const projectsReducer = combineReducers({
    projectForm:projectFormReducer,
    projectsList:projectsListReducer,
    projectDetails:projectDetailsReducer
  })

export default projectsReducer
  